import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-invalid", "value"]

import { useEventListener } from '@vueuse/core';
import { computed, useCssModule, useTemplateRef } from 'vue';
import widthStyles from '@/shared/legacy/ui/css/widths.module.css';
import { useVisibilityObserver } from '@/shared/lib/visibility-observer';


export default /*@__PURE__*/_defineComponent({
  __name: 'input',
  props: {
    id: { default: '' },
    value: {},
    invalid: { type: Boolean, default: false },
    focus: { type: Boolean, default: false },
    big: { type: Boolean, default: false },
    size: { default: 'full' },
    arrowDisable: { type: Boolean, default: false },
    withTrim: { type: Boolean, default: false }
  },
  emits: ["inputValue", "input"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emits = __emit;

const style = useCssModule();
const className = computed(() => {
  const sizeClassName = widthStyles[__props.size];
  return {
    [style.formControl]: true,
    [sizeClassName]: Boolean(sizeClassName),
    [style.big]: __props.big,
    [style.arrow]: __props.arrowDisable,
    [style.invalid]: __props.invalid
  };
});

const inputElement = useTemplateRef<HTMLInputElement>('input');

const handleInput = (event: Event) => {
  let inputValue = inputElement.value?.value || '';

  if (__props.withTrim) {
    inputValue = inputValue.trim();
  }

  emits('inputValue', inputValue);
  emits('input', event);
};

const setFocus = () => {
  inputElement.value?.focus();
};

__expose({
  setFocus
});

useVisibilityObserver(inputElement, () => {
  if (__props.focus) {
    setFocus();
  }
});
useEventListener(document.body, 'keydown', (event) => {
  // Исправляет ошибку в Safari, при которой после закрытия
  // модального окна через Esc, содержащее поле ввода с фокусом
  // (причём фокус при монтировании, после setFocus()),
  // может срабатывать непонятный скролл
  if (event.key === 'Escape' && document.activeElement === inputElement.value) {
    inputElement.value?.blur();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps(_ctx.$attrs, {
    id: __props.id,
    ref: "input",
    "aria-invalid": __props.invalid ? 'true' : 'false',
    value: __props.value,
    class: className.value,
    onInput: handleInput
  }), null, 16, _hoisted_1))
}
}

})